import React from 'react';
import { Button } from '@saucelabs/sl-component-buttons';
import Modal from '@saucelabs/ds-modal';
import { modalConnectV2, modalActions } from '@saucelabs/sl-container-modal';
import { useDispatch } from 'react-redux';

import Styles from './TestFairyTermsModal.styles';
import { TESTFAIRY_TERMS_MODAL } from '../constants';

export const TestFairyTermsModalInner = (props) => (
  <Modal
    emphasis="low"
    size="large"
    title="TestFairy Service-Specific Terms"
  >
    <ul className="m-0 pl-3 text-sm">
      <li>
        Use of Sauce Labs’ TestFairy service may require the installation of the TestFairy
        software development kit (the “SDK”) within Customer’s mobile application
        (the “Application”). The SDK allows Customer to record video streams or other end
        user activity within the Application and can be configured by Customer to collect log
        data, device information, and feedback submitted by an end user
        (together, the “Incident Data”) to assist with bug and crash identification,
        analysis, and correction.
      </li>
      <li>
        The Incident Data is collected solely for Customer’s use and is not utilized by
        Sauce Labs for any other purpose.  If such data will include “Personal Data” relating
        to data subjects resident in the European Economic Area, the United Kingdom, or
        Switzerland, Sauce Labs will enter into standard contractual clauses for
        controller-to-processor data transfers upon request.
      </li>
      <li>
        The TestFairy service is intended to be used to distribute Customer’s Application
        to end users in a testing capacity and should not be utilized to distribute
        Customer’s Application to end users who are not engaged by Customer as testers of
        the Application.
      </li>
      <li>
        When Customer’s Application contains the SDK, Customer is required to notify end
        users, in compliance with applicable law, regarding Customer’s data collection
        practices and Sauce Labs’ role, via the TestFairy SDK, as a subprocessor with respect
        to such data.  Customer is solely responsible for ensuring that such notification,
        and Customer’s use of the SDK, complies at all times with Customer’s privacy policy
        and all applicable laws of the jurisdictions within which Customer operates.
      </li>
      <li>
        Sauce Labs makes tools available to allow Customer to mask any personal data
        or other sensitive information that may be captured using the SDK.  Customer is
        solely responsible for utilizing these masking tools and Sauce Labs shall have no
        liability to Customer or any end-user as a result of Customer’s failure to implement
        or maintain these tools.
      </li>
      <li>
        If Customer elects to distribute an Application containing the SDK via any public
        distribution platform, such as the Apple App Store, Google Play, or similar
        third-party platform (a “Third Party Distribution Platform”), Customer is solely
        responsible and liable for continued compliance with such Third Party Distribution
        Platform’s guidelines and requirements.
      </li>
      <li>
        The licensing provisions set forth in Customer’s agreement with Sauce Labs are hereby
        amended as necessary to include the right for Customer to sub-license the SDK for the
        limited purpose of distributing Customer’s Application via a Third Party Distribution
        Platform.
      </li>
    </ul>
  </Modal>
);

const ConnectedModal = modalConnectV2(TESTFAIRY_TERMS_MODAL, TestFairyTermsModalInner);

const TestFairyTermsModal = () : JSX.Element => {
  const dispatch = useDispatch();

  return (
    <>
      <p className={Styles.terms}>
        By completing the purchase, I acknowledge that our organizations&apos;s
        use of the TestFairy platform is subject to the
        {' '}
        <Button
          category="link"
          className={Styles.button}
          onClick={() => {
            dispatch(modalActions.showModal(TESTFAIRY_TERMS_MODAL));
          }}
        >
          TestFairy specific terms
        </Button>
        {' '}
        in addition to the
        {' '}
        <a
          href="https://saucelabs.com/terms-of-service"
          rel="noopener noreferrer"
          target="_blank"
        >
          Sauce Labs Terms of Service
        </a>
        {''}
        .
      </p>
      <ConnectedModal />
    </>
  );
};

export default TestFairyTermsModal;
